export default '\u00a0';
